import 'client-only';

import { trackEvent, AnalyticsEvent } from '@/utils/analytics';

const useTrackFieldEvent = () => {
  const trackFieldEvent =
    (eventName: AnalyticsEvent) =>
    (field: string, orderNumber = 0, value = '') => {
      trackEvent(eventName, {
        field,
        orderNumber,
        value,
      });
    };

  const trackFieldEntered = trackFieldEvent(AnalyticsEvent.FIELD_ENTERED);

  const trackFieldFocused = trackFieldEvent(AnalyticsEvent.FIELD_FOCUSED);

  return { trackFieldEntered, trackFieldFocused };
};

export { useTrackFieldEvent };
